module.exports = __webpack_public_path__ + "static/media/Lahore High Court W. c. 1925.7b4a0051.jpg";